
export enum ActivityType {
    EntityComment = 'EntityComment',
    EntityAttachment = 'EntityAttachment',
    EntityCreated = 'EntityCreated',
    EntityDeleted = 'EntityDeleted',
    EntityUpdated = 'EntityUpdated',
    EntityMerged = 'EntityMerged',
    WorkOrderAssigned = 'WorkOrderAssigned',
    WorkOrderUnassigned = 'WorkOrderUnassigned',
    WorkOrderDispatched = 'WorkOrderDispatched',
    WorkOrderSubcontractorDispatched = 'SubcontractorWorkOrderDispatched',
    WorkOrderStarted = 'WorkOrderStarted',
    WorkOrderCheckIn = 'WorkOrderCheckIn',
    WorkOrderCheckout = 'WorkOrderCheckout',
    WorkOrderInProgress = 'WorkOrderInProgress',
    WorkOrderCompleted = 'WorkOrderCompleted',
    WorkOrderCancelled = 'WorkOrderCancelled',
    WorkOrderClosed = 'WorkOrderClosed',
    WorkOrderStop = 'WorkOrderStop',
    WorkOrderHold = 'WorkOrderHold',
    WorkOrderFinalised = 'WorkOrderFinalised',
    WorkOrderResumeNew = 'WorkOrderResumeNew',
    WorkOrderResumeAssigned = 'WorkOrderResumeAssigned',
    WorkOrderResumeDispatched = 'WorkOrderResumeDispatched',
    WorkOrderReissued = 'WorkOrderReissued',
    WorkOrderUpdated = 'WorkOrderUpdated',
    WorkOrderSendEmail = 'WorkOrderSendEmail',
    WorkOrderEnroute = 'WorkOrderEnroute',
    WorkOrderOnsite = 'WorkOrderOnsite',
    JobBilled = 'JobBilled',
    JobPaid = 'JobPaid',
    JobCompleted = 'JobCompleted',
    JobFinalised = 'JobFinalised',
    JobClosed = 'JobClosed',
    JobCancelled = 'JobCancelled',
    JobOnHold = 'JobOnHold',
    JobInProgress = 'JobInProgress',
    JobReOpen = 'JobReOpen',
    JobImport = 'JobImport',
    JobUpdateThresholds = 'UpdateJobThresholds',
    JobChanged = 'JobChanged',
    ChecklistConfirmation = 'ChecklistConfirmation',
    ChecklistAttachment = 'ChecklistAttachment',
    ChecklistSignature = 'ChecklistSignature',
    ChecklistComment = 'ChecklistComment',
    ChecklistBeforePhoto = 'ChecklistBeforePhoto',
    ChecklistDuringPhoto = 'ChecklistDuriingPhoto',
    ChecklistAfterPhoto = 'ChecklistAfterPhoto',
    ChecklistMandatory = 'ChecklistMandatory',
    WorkOrderDeleted = 'WorkOrderDeleted',
    WorkOrderBill = 'WorkOrderBill',
    WorkOrderAddCode = 'WorkOrderAddCode',
    WorkOrderUpdatedCode = 'WorkOrderUpdatedCode',
    WorkOrderDeletedCode = 'WorkOrderDeletedCode',
    JobResumeNew = 'JobResumeNew',
    JobUpdated = 'JobUpdated',
    AnswerQuestion = 'AnswerQuestion',
    WorkOrderUpdateCompletedDate = 'UpdateWorkOrderCompletedDate',
    WorkOrderUpdateFinalisedDate = 'UpdateWorkOrderFinalisedDate',
    WorkOrderUpdateThresholds = 'UpdateWorkOrderThresholds',
    WorkOrderUpdateBuyPriceBook = 'WorkOrderUpdateBuyPriceBook',
    Form = 'Form',
    InvoiceUpdated = 'Invoice Updated',
    InvoiceApproved = 'Invoice Approved',
    InvoiceError = 'Invoice Error',
    InvoiceCreated = 'Invoice Created',
    InvoiceVoid = 'Invoice Voided',
    InvoiceReissue = 'Invoice Reissue',
    InvoiceSynced = 'Invoice Synced',
    InvoicePayment = 'Invoice Payment',
    InvoiceEditedAfterApproval = 'Invoice Edited After Approval',
    BillUpdated = 'Bill Updated',
    BillApproved = 'Bill Approved',
    BillError = 'Bill Error',
    BillCreated = 'Bill Created',
    BillVoid = 'Bill Voided',
    BillReissue = 'Bill Reissue',
    BillSynced = 'Bill Synced',
    BillPayment = 'Bill Payment',
    BillEditedAfterApproval = 'Bill Edited After Approval',
    ComplianceSendRequest = 'Compliance Send Request',
    QuoteWon = 'Quote Won',
    QuoteLost = 'Quote Lost',

    QuoteCreated = 'Quote Created',
    QuoteApproved = 'Quote Approved',
    QuoteAccepted = 'Quote Accepted',
    QuoteDeclined = 'Quote Declined',
    QuoteRevised = 'Quote Revised',
    QuoteDeleted = 'Quote Deleted',
    QuoteSubmitForApproval = 'Quote Submit For Approval',
    QuoteChangesRequired = 'Quote Changes Required',
    QuoteConverted = 'Quote Converted',


    Incomplete = 'Incomplete',
    ClearFinalisation = 'ClearFinalisation',
    Reverse = 'Reverse',
    Integration = 'Integration',
    Allocation = 'Allocation',
    Utility = 'Utility',
    Defect = 'Defect',
    ClaimSubmitted = 'Claim Submitted',
    ClaimApproved = 'Claim Approved',
    ClaimRework = 'Claim Rework',

    WorkBuddyConnectWorkOrderCompleted = 'WorkBuddy Connect: Work Order Completed',
    WorkBuddyConnectWorkOrderCompletedResponse = 'WorkBuddy Connect: Work Order Completed Response',
    WorkBuddyConnectError = 'WorkBuddy Connect: Error',
    Timesheet = 'Timesheet',
    EmailEditor = 'EmailEditor',
    SendEmailNotification = 'Send Email Notification',
    SendSmsNotification = 'Send Sms Notification',
    SendEmailTemplate = 'Send Email Template',
    SendSmsTemplate = 'Send Sms Template',
    OpportunityCreated = 'Opportunity Created',
    OpportunityStageChanged = 'Opportunity Stage Changed',
    OpportunityWon = 'Opportunity Won',
    OpportunityLost = 'Opportunity Lost',
    OpportunityDeleted = 'Opportunity Deleted',

    LeadCreated = 'Lead Created',
    LeadStageChanged = 'Lead Stage Changed',
    LeadConverted = 'Lead Won',
    LeadDeleted = 'Lead Deleted',

    ProjectCreated = "Project Created",
    ProjectDeleted = "Project Deleted",
    ProjectStatusChanged = "Project Status Changed",
    ProjectClosed = "Project Closed",

    File = 'File',
    Notification = 'Notification',
    Reminder = 'Reminder',

    SaleOrderCreated = 'SaleOrder Created',
    SaleOrderUpdateStatus = 'SaleOrder Update Status',
    SaleOrderInvoiced = 'SaleOrder Invoiced',
    SaleOrderDeleted = 'SaleOrder Deleted',

    EntityStatusUpdated = 'Entity Status Updated',

    RecurringJobUpdated = 'Recurring Job Updated',

    SiteIntegrationSync = 'Site Integration Sync',
}

export enum ActivityKind {
    Email = 'Email',
    SMS = 'SMS',
    Integration = 'Integration',
    Phone = 'Phone',
    System = 'System',
    Appointment = 'Appointment',
    Note = 'Note',
    Form = 'Form',
    File = 'File',
    View = "View",
}

export const ActivityKinds = Object.values(ActivityKind);